import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ConfirmationDialog from 'src/components/ConfirmationDialog';
import { useRightSidebar } from 'src/layouts/right-side-bar/rightSidebarProvider';
import HttpServices from 'src/services/httpService';
import { reportModuleURL } from 'src/services/urlService';
import { useToaster } from 'src/utils/toaster/toasterContext';
import ScheduledReportEditView from '../scheduledEditView.component';
import ScheduledReportActionPopup from './PostGridActionPopup.component';

const ScheduledReportGridAction = ({ scheduledList, handleReCallScheduleReport }) => {
  const { t: translate } = useTranslation();

  const navigate = useNavigate();
  const { showToast } = useToaster();
  const [selectedPopOverPost, setPopOverPost] = useState(null);
  const [popoverElement, setPopoverElement] = useState(null);
  const [loading, setLoading] = useState(false);
  const { showRightSidebar } = useRightSidebar();
  const [confirmationDialogue, setConfirmationDialogue] = useState(null);

  const handleOpenMenu = (event, scheduledList) => {
    setPopOverPost(scheduledList);
    setPopoverElement(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setPopOverPost(null);
    setPopoverElement(null);
  };

  const closeConfirmationDialogue = () => {
    setConfirmationDialogue(null);
  };

  const failureCallback = (message) => {
    message && showToast(message, 'e');
    handleCloseMenu();
    setLoading(false);
    closeConfirmationDialogue();
  };
  const handleEditScheduledReport = () => {
    let data = {
      content: sideBarView,
    };
    showRightSidebar(data);
    handleCloseMenu();
  };
  const sideBarView = () => {
    return (
      <ScheduledReportEditView handleReCallScheduleReport={handleReCallScheduleReport} currReportData={scheduledList} />
    );
  };

  const handleDeleteReport = () => {
    handleCloseMenu();
    setConfirmationDialogue({
      isOpen: true,
      title: translate('common.confirm_deletion'),
      message: translate('scheduled_reports.want_to_delete_draft'),
      submitFunction: confirmDeletePost,
    });
  };

  const confirmDeletePost = () => {
    let postProps = {
      url: reportModuleURL.deleteScheduledReport,
      body: {
        report_id: scheduledList.id,
      },
      successCallback: deleteSuccessCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
    closeConfirmationDialogue();
  };

  const deleteSuccessCallback = (data, message) => {
    message && showToast(message);
    handleCloseMenu();
    closeConfirmationDialogue();
    handleReCallScheduleReport();
  };

  const postActionProps = {
    loading,
    popoverElement: popoverElement,
    handleCloseMenu,
    handleEditScheduledReport,
    handleDeleteReport,
    selectedPopOverPost: selectedPopOverPost,
  };

  return (
    <>
      <Box display="flex" alignItems="right">
        <IconButton
          size="large"
          color="inherit"
          onClick={(e) => {
            handleOpenMenu(e, scheduledList);
          }}
          sx={{ padding: '6px', marginRight: '2px' }}
        >
          <MoreVertIcon />
        </IconButton>
        <ScheduledReportActionPopup {...postActionProps} />
      </Box>
      {confirmationDialogue && (
        <ConfirmationDialog
          open={confirmationDialogue.isOpen}
          onClose={() => closeConfirmationDialogue()}
          onConfirm={confirmationDialogue.submitFunction}
          title={confirmationDialogue.title}
          message={confirmationDialogue.message}
        />
      )}
    </>
  );
};

export default ScheduledReportGridAction;
